module.exports = require('./dist/animate-components.min.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/animate-components/main.js
// module id = 1
// module chunks = 0